import { render } from "./UiDocumentErrorCurrent.pug?vue&type=template&id=bd73da68&lang=pug"
import script from "./UiDocumentErrorCurrent.js?vue&type=script&lang=js"
export * from "./UiDocumentErrorCurrent.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__